import App from './../../App'
import {html, render } from 'lit-html'
import {anchorRoute, gotoRoute} from './../../Router'
import Auth from './../../Auth'
import Utils from './../../Utils'

class SignInView {
  init(){
    console.log('SignInView.init')
    document.title = 'Sign In'
    this.render()
    Utils.pageIntroAnim()
  }

  signInSubmitHandler(e){
    e.preventDefault()
    const formData = e.detail.formData
    const submitBtn = document.querySelector('.submit-btn')
    submitBtn.setAttribute('loading', '')    
    
    // sign in using Auth    
    Auth.signIn(formData, () => {
      submitBtn.removeAttribute('loading')
    })
  }

  render(){    
    const template = html`      



      <div class="signinpage">
      <div class="imagebox">
      
          <div class="overlaybox" >
          <div class="app-header-main">
    
          <img class="signlogo" src="/images/logo.svg">
        
          </div>

          <div id="textboxovl" class="animate__animated animate__fadeInLeft ">
            <h1  class="overlaytitle" >The #1 <span style="color:#FFA132; font-weight:700;"> home service </span> <br> platform in Mauritius.</h1>
            <p class="overlaytext">Looking to grow your <span style="color:#FFF; font-weight:600;">home service business</span> or <span style="color:#FFF; font-weight:600;">hire <br>someone</span> to do a job at your house? </p>
            
            
            
            
            
            <p>We’ll set you up with <span style="color:#FFA132; font-weight:600;">clients</span> or <span style=" font-weight:600;">workers</span> <br>in no time.</p>
          
          
          </div>
          </div>
      </div>


        <div class="signinup-box">

        <div>
        <h3>LOGIN</h3>
            <h2>Let's get some work done.</h2>
        </div>
                
          <sl-form class="form-signup dark-theme" @sl-submit=${this.signInSubmitHandler}>          
            <div class="input-group">
           
              <sl-input label="Email" name="email" type="email" placeholder="example@something.com" required></sl-input>
            </div>
            <div class="input-group">
            
              <sl-input name="password" label="Password" type="password" placeholder="************" required toggle-password ></sl-input>
            </div><br>
            <sl-button class="submit-btn" type="primary" submit style="width: 100%;">LOG IN</sl-button>
            
            <br><br>

          <h3>SIGN UP</h3>
          <p class="text">New to fixtou?</p>
            

          <div class="signup-btns" name="accessLevel"> 
            <a class="customer" name="accessLevel" value="1"  href="/signup" @click=${anchorRoute}>Sign Up As a <span>customer<span></a> <br>
            <a class="pro" name="accessLevel" value="2" href="/prosignup" @click=${anchorRoute};">Sign Up As a <span>professional<span></a>
          </div>

          

         
          
        </div>
      </div>
    `
    render(template, App.rootEl)    
  }
}

export default new SignInView()